import { TokenResponse } from '@features/auth/types/token-response.ts';

import { makeStorage } from '@/core/storage/storage.ts';

type LocalStorageKey = 'ff-api-token';

type LocalStorageData = {
  'ff-api-token': TokenResponse;
};

const appLocalStorage = makeStorage<LocalStorageData>(window.localStorage);

export {
  appLocalStorage,
  type LocalStorageData,
  type LocalStorageKey
};
